import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class Endereco implements Construtor<Endereco> {

  public idEndereco: number;
  public logradouro: string;
  public numero: number;
  public cep: string;
  public complemento: string;
  public estado: string;
  public cidade: string;
  public bairro: string;
  public index: number;

  constructor(object?: any) {

    if (object !== undefined && object !== null) {
      if (object instanceof Endereco) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }
      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  get obterIdEndereco(): number {
    return this.idEndereco;
  }

  set IdEndereco(id: any) {
    this.idEndereco = id;
  }

  get obterLogradouro(): string {
    return this.logradouro.slice(0);
  }

  set Logradouro(logradouro: any) {
    this.logradouro = StringValidacao.copiarStringValida(logradouro);
  }

  get obterNumero(): number {
    return this.numero;
  }

  set Numero(numero: any) {
    this.numero = numero;
  }

  get obterCep(): string {
    return this.cep;
  }

  set Cep(cep: any) {
    this.cep = cep;
  }

  get obterComplemento(): string {
    if (this.complemento !== undefined) {
      return this.complemento.slice(0);
    } else {
      return undefined;
    }
  }

  set Complemento(complemento: any) {
    this.complemento = StringValidacao.copiarStringValida(complemento);
  }

  get obterCidade(): string {
    return this.cidade.slice(0);
  }

  set Cidade(cidade: any) {
    this.cidade = StringValidacao.copiarStringValida(cidade);
  }

  get obterEstado(): string {
    return this.estado.slice(0);
  }

  set Estado(estado: any) {
    this.estado = StringValidacao.copiarStringValida(estado);
  }

  copyObject(endereco: Endereco): void {
    this.idEndereco = endereco.obterIdEndereco;
    this.logradouro = endereco.obterLogradouro;
    this.numero = endereco.obterNumero;
    this.cep = endereco.obterCep;
    this.complemento = endereco.obterComplemento;
    this.cidade = endereco.obterCidade;
    this.estado = endereco.obterEstado;
    this.bairro = endereco.bairro;
  }

  parseFromJson(endereco: any): void {
    this.IdEndereco = endereco.idEndereco;
    this.Logradouro = endereco.logradouro;
    this.Numero = endereco.numero;
    this.Cep = endereco.cep;
    this.Complemento = endereco.complemento;
    this.Cidade = endereco.cidade;
    this.Estado = endereco.estado;
    this.bairro = endereco.bairro;
  }

  modeloCompleto(): boolean {
    return this.logradouro !== undefined &&
      this.numero !== undefined &&
      this.cep !== undefined &&
      this.cidade !== undefined &&
      this.estado !== undefined;
  }

  getNewInstance(object?: any): Endereco {
    return new Endereco(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/endereco.ts